module.exports = {
	"fi": {
		"help-tool": {
			"button-text": "Apua",
			"support-button": "Pyydä tukea",
			"support-page": {
				"create-ticket": {
					"title": "Pyydä tukea",
					"instructions": "Lähetä alla oleva pyyntö, ja vastaamme sinulle 1 arkipäivän kuluessa.",
					"related-content": {
						"title": "Nämä saattavat auttaa sinua ratkaisemaan ongelman"
					},
					"fields": {
						"mid": {
							"label": "Valitse kauppa",
							"validation": "Kauppa on pakollinen"
						},
						"phoneNumber": {
							"label": "Puhelinnumero (valinnainen)"
						},
						"topic": {
							"question": "Mitä kysymyksesi koskee?",
							"label": "Valitse aihe",
							"validation": "Aihe on pakollinen",
							"options": {
								"orders": "Tilaukset",
								"settlements": "Tilitykset",
								"agreements": "Sopimukset",
								"others": "Muu"
							}
						},
						"subject": {
							"label": "Aiherivi",
							"validation": "Aiherivi on pakollinen"
						},
						"description": {
							"label": "Viesti",
							"validation": "Kuvaus on pakollinen"
						},
						"attachment": {
							"label": "Lisää liitteitä",
							"button": "Lataa",
							"info": "Näyttökaappauksen avulla selvitämme ongelman nopeammin.",
							"supportedFileTypes": "Tuetut tiedostomuodot: .png, .jpg, .pdf",
							"error": "Tiedostojen koko ei saa ylittää kokonaisuudessaan {maxSize} MB"
						}
					},
					"submit": "Lähetä pyyntö",
					"service-unavailable-error": "Hups! Jokin meni vikaan, yritä uudelleen muutaman minuutin kuluttua. Mikäli ongelma jatkuu, {link}.",
					"generic-error": "Emme pystyneet käsittelemään pyyntöäsi. Järjestelmiemme välillä on kommunikaatiokatkos. Päivitä sivu tai yritä myöhemmin uudelleen. Mikäli ongelma jatkuu, {link}.",
					"contact-link": "ota meihin yhteyttä"
				},
				"view-ticket": {
					"title": "Valmista on!",
					"details": "Olemme vastaanottaneet pyyntösi, ja vastaamme sinulle 1 arkipäivän kuluessa. Tässä ovat tietosi:",
					"ticket": "Pyynnön numero {ticketId}",
					"email": "Sähköposti: {email}",
					"status": "Voit seurata tilaa tukisivullamme.",
					"track": "Seuraa tilaa"
				}
			},
			"header": {
				"homeLink": "Nollaa"
			},
			"home": {
				"greeting": "Hei {givenName}! Miten voimme auttaa sinua?",
				"topics": "Missä asiassa tarvitset apua?"
			},
			"topics": {
				"expandButton": "Lisää"
			},
			"feedback": {
				"title": "Oliko tästä apua?",
				"optionYes": "Kyllä, tästä oli apua",
				"optionNo": "Ei, tarvitsen vielä apua",
				"positiveFeedback": "Kiitos positiivisesta palautteestasi! Se auttaa meitä tarjoamaan sinulle tulevaisuudessa sinua kiinnostavia artikkeleja."
			},
			"freeTextFeedback": {
				"title": "Auta meitä parantamaan toimintaamme",
				"placeholder": "Miksi tämä sisältö ei ollut mielestäsi hyödyllistä?",
				"submitButton": "Lähetä",
				"feedbackMessage": "Kiitos palautteestasi! Se auttaa meitä tarjoamaan sinulle tulevaisuudessa sinua kiinnostavia artikkeleja."
			},
			"relatedContent": {
				"title": "Asiaan liittyvä sisältö"
			},
			"search": {
				"buttonLabel": "Etsi",
				"input": "Hae artikkeleja...",
				"loading": "Ladataan...",
				"results": {
					"contact": "Etkö löydä apua ongelmaasi?",
					"empty": "Valitettavasti haullasi ei löytynyt yhtään tulosta. Yritä hakea toisella hakusanalla.",
					"singleTopicFound": "Löysimme 1 aiheen",
					"multipleTopicsFound": "Löysimme {count} aihetta",
					"singleArticleFound": "Löysimme 1 artikkelin",
					"multipleArticlesFound": "Löysimme {count} artikkelia"
				}
			},
			"contact": {
				"title": "Ota meihin yhteyttä",
				"channelsIntro": "Ota meihin yhteyttä, jotta voimme auttaa sinua.",
				"businessDetailsTitle": "Yrityksesi tiedot",
				"businessDetailsName": "Yrityksen nimi",
				"businessDetailsEmail": "Sähköposti",
				"businessDetailsMid": "Kaupan tunnus",
				"phone": {
					"title": "Soita meille",
					"paragraph": "Voit soittaa meille arkisin virka-aikaan. Jos olet Ruotsissa tai Yhdistyneessä kuningaskunnassa, voit soittaa meille myös viikonloppuisin klo 10–16."
				},
				"email": {
					"title": "Lähetä meille sähköpostia",
					"paragraph": "Lähetä meille sähköpostia ja otamme sinuun yhteyttä mahdollisimman pian."
				}
			},
			"errorBoundary": {
				"title": "Jotain meni pieleen",
				"message": "Pahoittelemme, mutta tapahtui virhe. Voit napsauttaa \"Palaa takaisin\"-painiketta alta, jolloin palaat takaisin Ohje-työkaluun. Voit myös ottaa meihin yhteyttä napsauttamalla \"Pyydä tukea\" -painiketta.",
				"resetButton": "Palaa takaisin",
				"errorId": "Virhetunnus: {errorId}"
			},
			"tour": {
				"prev": "Edellinen",
				"next": "Seuraava",
				"done": "Valmis"
			},
			"notAvailableMobile": {
				"title": "Ei saatavilla",
				"buttonBack": "Takaisin",
				"paragraph": "Tämä sisältö ei ole saatavilla laitteellasi. Yritä avata se laitteella, jossa on suurempi näyttö, kuten pöytätietokoneella."
			},
			"shareButton": {
				"title": {
					"article": "Jaa linkki tähän artikkeliin",
					"topic": "Jaa linkki tähän aiheeseen",
					"tour": "Jaa linkki tähän kierrokseen"
				},
				"radioItemHome": "Etusivusovellus",
				"descriptionHome": "Avaa tukiartikkelin Kauppiasportaalin etusivulla",
				"radioItemCurrent": "Nykyinen sivu",
				"descriptionCurrent": "Avaa tukiartikkelin nykyisellä sivulla"
			},
			"marketSelector": {
				"whichMarketToContact": "Mihin markkina-alueeseen haluat saada yhteyden?"
			}
		},
		"orientation": {
			"title": "Opi lisää aiheesta ..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Hei {name}! 👋 Olen Klarna-avustajasi.",
				"whatDoYouNeedHelpWithPart2": "Minun avullani löydät ratkaisun monessa tapauksessa alle 5 minuutissa.",
				"whatDoYouNeedHelpWithPart3": "Miten voin auttaa sinua tänään?",
				"selectSupportChannel": "Ota yhteyttä tukipalveluumme valitsemalla kanava.",
				"selectPayoutIssue": "Täydellistä! Jatka eteenpäin ja valitse tilityksiin liittyvä ongelma 👇",
				"selectOrderIssue": "Täydellistä! Jatka eteenpäin ja valitse tilauksiin liittyvä ongelma 👇",
				"capturedOrders": "Onko sinulla yhtään {link1} -tilausta?",
				"capturedOrdersLink1": "aktivoitu",
				"notPaidOrder": {
					"isScheduleFollowed": "Onko {link1} (maksuviive mukaan lukien) noudatettu?",
					"isScheduleFollowedLink1": "maksuaikataulu",
					"isHoldbackOrDebt": "Jos maksuviive on jo kulunut, tarkista {link1}. Onko palautusten/kumoamisten vuoksi pidätyksiä tai velkaa?",
					"isHoldbackOrDebtLink1": "uusin tilitystiedosto"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Varmista, mikä on niiden tilausten aktivointipäivä, joista odotat saavasi tilityksen, ja ota maksuviive huomioon. Löydät tilauksesi kohdasta {link1}. Onko tilaukset, joista odotat tilityksiä, aktivoitu?",
					"isScheduleFollowedLink1": "EU-direktiivistä"
				},
				"changePaymentFrequency": "Oletko saanut yli 30 aktivoitua tilausta kuukaudessa 3 kuukauden ajanjaksolla?",
				"whenWillGetPaid": "Tilityspäivä riippuu sopimuksessasi määritellystä tilitysaikataulusta ja tilitysviiveestä (ehdot). Jos et ole varma, mitkä tilityksesi asetukset ovat, voit tarkistaa ne kohdasta {link1}. Onko maksuaikataulua (sekä maksuviivettä) noudatettu?",
				"whenWillGetPaidLink1": "Tilitykset",
				"thatHelped": "Kiitos positiivisesta palautteestasi. Se auttaa meitä jatkossakin tarjoamaan sinulle juuri oikeanlaista tukea. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Nyt ymmärrän! Onko sinulla yhtään aktivoimatonta tilausta?",
					"haveUncapturedOrdersPart2": "Jos et tiedä, miten asia tarkistetaan, siirry kohtaan {link1}.",
					"haveUncapturedOrdersPart2Link1": "hankkia sen",
					"expirationDateSurpassed": "Onko aktivoinnin eräpäivä mennyt? (tavallisesti se on 28 päivän kuluttua)",
					"customerCreditPaymentMethod": "Valitsiko asiakas maksutavaksi luoton (lasku, tili, suoraveloitus)?",
					"isOrderCaptured": "Onko tilaus {link1}?",
					"isOrderCapturedLink1": "aktivoitu"
				}
			},
			"options": {
				"payout": "Maksut",
				"orders": "Tilaukset",
				"otherIssue": "Muut ongelmat",
				"whenPaidOrderNext": "Milloin saan seuraavan maksun?",
				"notPaidOrder": "En ole saanut maksua",
				"paidWrongAmount": "Minulle maksettiin virheellinen summa",
				"changeHowOftenPaid": "Haluan muuttaa sitä, miten usein saan maksun",
				"dontKnowHowToCaptureOrder": "En tiedä, miten tilaus aktivoidaan",
				"missedCaptureDeadline": "Aktivoinnin eräpäivä jäi minulta välistä",
				"needToRefundAnOrder": "Minun tulee hyvittää tilaus",
				"yes": "Kyllä",
				"no": "Ei",
				"partially": "Osittain",
				"iNeedMoreHelp": "Tarvitsen lisää apua",
				"thatHelped": "Tästä oli apua",
				"contactSupportChannel": "Ota yhteyttä tukikanaviin"
			},
			"explanations": {
				"noCapturedOrders": "Mutta edetään asia kerrallaan. Ensin sinun tulee {link1}. Kun olet aktivoinut tilauksen, maksamme summan pankkitilillesi. Kulut, palautukset ja muut veloitukset vähennetään tästä summasta.",
				"noCapturedOrdersLink1": "aktivoida tilaus",
				"feesReturnsHoldbacks": "Kulut, palautukset ja muut veloitukset vähennetään tilityssummasta. Tarkista, onko {link1} palautusten/kumoamisten vuoksi pidätyksiä tai velkaa.",
				"feesReturnsHoldbacksLink1": "uusimmassa tilitystiedostossa",
				"notPaidOrder": {
					"scheduleFollowed": "Kun olet aktivoinut tilauksen, maksamme summan pankkitilillesi tilitysaikataulusi mukaisesti. Kulut, palautukset ja muut veloitukset vähennetään tästä summasta. Tarkista tilityssumma {link1}.",
					"scheduleFollowedLink1": "uusimmasta tilitystiedostosta",
					"noHoldback": "Tarkista, että pankkitilitietosi ovat oikein tilityksen valuuttaa koskien {link1}.",
					"noHoldbackLink1": "EU-direktiivistä",
					"withHoldback": "Jos aktivoitujen tilausten summa ylittää velan, tarkista, että pankkitilitietosi ovat oikein tilityksen valuuttaa koskien {link1}.",
					"withHoldbackLink1": "EU-direktiivistä"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Saat seuraavan tilityksen tilitysaikataulun mukaan, tilitysviiveen huomioiden."
				},
				"changePaymentFrequency": {
					"isAble": "Jatka ottamalla yhteyttä tukeemme alla olevien kanavien kautta.",
					"isUnable": "Et valitettavasti täytä vaatimuksia, jotta voisit muuttaa tilitysaikatauluasi."
				},
				"orders": {
					"uncapturedDynamicYes": "Sinulla on näköjään {number} aktivoimatonta tilausta.",
					"uncapturedDynamicNo": "Sinulla ei näköjään ole aktivoimattomia tilauksia",
					"uncapturedYesPart1": "On siis aika aktivoida tilauksia! Aktivoi tilaukset seuraavasti",
					"uncapturedYesPart2": "1. Siirry Tilaukset-sivulle {link1}.",
					"uncapturesYesPart2Link1": "klikkaamalla tästä",
					"uncapturedYesPart3": "2. Klikkaa sen tilauksen Klarna-viitettä, jonka haluat aktivoida",
					"uncapturedYesPart4": "3. Valitse aktivoitavat tuotteet tai lisää summa, jonka haluat aktivoida",
					"uncapturedYesPart5": "4. Paina ”Aktivoi”",
					"uncapturedNoPart1": "Jos haluat aktivoida tilauksen, sinulla tulee ensin olla tilauksia aktivoitavana.",
					"uncapturedNoPart2": "Aktivoimalla tilauksen vahvistat samalla, että olet lähettänyt tilauksen asiakkaalle. Tämä tulee aina tehdä samana päivänä, jolloin tilaus on lähetetty. Kun aktivoit tilauksen, ilmoitat samalla meille, että meidän tulee käynnistää tästä tilauksesta sinulle tilitys. Lue lisää tilauksen aktivoimisesta {link1}.",
					"uncapturedNoLink1": "EU-direktiivistä",
					"customerCreditPaymentMethodNo": "Emme valitettavasti voi siirtää vanhentuneen tilauksen aktivoinnin eräpäivää. Sinun tulee luoda tilaus uudelleen.",
					"expirationDateSurpassedYes": "Autamme sinua tilauksen aktivoinnin eräpäivän siirtämisessä mielellämme. Ota vain yhteyttä tukeemme käyttämällä jotakin alla olevista kanavista.",
					"expirationDateSurpassedNo": "Siirry kohtaan {link1}. Valitse tilaus merkitsemällä Klarnan viitenumeron vieressä oleva valintaruutu. Klikkaa Siirrä aktivoinnin eräpäivää ja vahvista pyyntösi.",
					"expirationDateSurpassedNoLink1": "Tilaukset > Aktivoitavat",
					"isOrderCapturedYesPart1": "Valitse tuotteet, jotka haluat hyvittää, ja klikkaa Hyvitä. Voit myös klikata ensin Hyvitä ja kirjoittaa summan, jonka haluat hyvittää. Päätä itse, kumpi sopii sinulle paremmin.",
					"isOrderCapturedYesPart2": "Asiakkaasi saa takaisinmaksun jo maksamastaan summasta 2–5 arkipäivän kuluessa. Tämä summa vähennetään seuraavasta tilityksestäsi.",
					"isOrderCapturedNo": "Jos sinulla on aktivoimaton tilaus, jota et aio lähettää, voit {link1} koko tilauksen. Siirry {link2} ja klikkaa Peruuta tilaus.",
					"isOrderCapturedNoLink1": "peruuttaa",
					"isOrderCapturedNoLink2": "tilaussivulle",
					"refundPartiallyCaptured": "Jos olet aktivoinut osittain tilauksen, jonka tuotteista olet jo lähettänyt osan etkä aio toteuttaa jäljelle jäänyttä osaa tilauksesta, vapauta tilauksen aktivoimaton osa. Siirry {link1}, klikkaa Lisää toimintoja ja valitse Vapauta.",
					"refundPartiallyCapturedLink1": "tilaussivulle"
				}
			},
			"messages": {
				"sorryToHearThat": "Harmi, ettei siitä ollut apua. Sinut ohjataan pian uudelleen ottamaan yhteyttä tukeemme."
			},
			"button": {
				"label": "Pyydä tukea"
			},
			"contact": {
				"chat": "Chattaa asiakaspalvelijan kanssa",
				"ticket": "Lähetä tukipyyntö",
				"times": {
					"minutes": "Jonotusaika: {time} minuutti(a)",
					"hours": "Jonotusaika: {time} tunti(a)",
					"days": "Jonotusaika: {time} päivä(ä)"
				}
			}
		}
	}
};